<template>
  <v-dialog lazy full-width width="290px" ref="dialog" v-model="visible">
    <v-text-field
      slot="activator"
      :value="display"
      @click:append="handleActivatorClick"
      @focus="$emit('focus')"
      :append-icon="clearable && modified ? 'mdi-close' : appendIcon"
      :error-messages="errorMessages"
      :placeholder="placeholder"
      :label="label"
      :required="required"
      :rules="rules"
      :hint="hint"
      :color="color"
      :prepend-icon="prependIcon"
      :disabled="disabled"
      readonly
      :persistent-hint="persistentHint"
    />

    <v-date-picker
      ref="picker"
      v-model="modified"
      :type="type"
      :max="max"
      :min="min"
      :color="color"
      :dark="dark"
      scrollable
      reactive
      :picker-date="defaultValue"
      :title-date-format="titleDateFormat ? () => `${titleDateFormat}` : null"
    >
      <v-spacer />
      <v-btn :color="theme ? theme.cancel : ''" flat @click.native="dismiss">Cancel</v-btn>
      <v-btn :color="theme ? theme.primaryActionButton : color" @click.native="update">
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
// Vue Component
export default {
  name: 'DatePicker',
  props: {
    appendIcon: { type: String },
    clearable: { type: Boolean, default: () => false },
    color: { type: String },
    disabled: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    defaultValue: { type: String },
    errorMessages: { type: Array, default: () => [] },
    hint: { type: String, default: '' },
    label: { type: String },
    max: { type: String },
    min: { type: String },
    persistentHint: { type: Boolean, default: () => true },
    placeholder: { type: String, default: 'Pick a date' },
    prependIcon: { type: String },
    required: { type: Boolean },
    rules: { type: Array, default: () => [] },
    showDay: { type: Boolean, default: () => true },
    theme: { type: Object },
    titleDateFormat: { type: String },
    type: { type: String, default: 'date' },
    value: { type: String },
    yearsFirst: { type: Boolean, default: false },
  },

  data() {
    return {
      visible: false,
      modified: this.$date(this.value ? new Date(this.value) : new Date(), 'yyyy-MM-dd'),
    }
  },
  computed: {
    display() {
      if (this.showDay) {
        return this.value ? this.$date(new Date(this.value), 'd MMMM yyy') : null
      } else {
        return this.value ? this.$date(new Date(this.value), 'MMMM yyy') : null
      }
    },
  },

  watch: {
    visible(val) {
      val && this.yearsFirst && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    value(val) {
      if (val) this.modified = this.$date(new Date(val), 'yyyy-MM-dd')
    },
  },

  methods: {
    dismiss() {
      this.visible = false
    },
    handleActivatorClick() {
      if (this.disabled) return

      if (this.clearable && this.modified) {
        this.clear()
      } else {
        this.visible = true
      }
    },
    update() {
      this.visible = false
      this.$emit('input', this.$date(new Date(this.modified)))
    },
    clear() {
      this.visible = false
      this.modified = null
      this.$emit('input', null)
    },
  },
}
</script>
